import { Component, type ErrorInfo, type ReactNode } from 'react';
import { logger } from '@/infra/logger/Logger';
import { ErrorFallback } from './ErrorFallback';

interface State {
  hasError: boolean;
}

interface Props {
  children: ReactNode;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(err: Error, info: ErrorInfo): void {
    logger.error('react.uncaught', err, { componentStack: info.componentStack ?? undefined });
  }

  private handleReload = (): void => {
    location.reload();
  };

  override render(): ReactNode {
    if (this.state.hasError) {
      return <ErrorFallback onReload={this.handleReload} />;
    }
    return this.props.children;
  }
}
